import { INTEGER_SEPARATOR, formatBalance } from "@cede/utils";

/** Groups an integer's digits in threes. */
const groupIntegerDigits = (integer: string): string => integer.replace(/\B(?=(\d{3})+(?!\d))/g, INTEGER_SEPARATOR);

/**
 * Formats a stat value with optional currency formatting
 *
 * @param {number | undefined} value - The value to format
 * @param {boolean} isMoney - Whether to format as currency with $ prefix
 * @param {boolean} isInteger - Whether to round to integer (for animated values)
 * @returns {string} Formatted value string
 */
export const formatStatValue = (value: number | undefined, isMoney: boolean, isInteger?: boolean): string => {
  if (value == null) return isMoney ? "$0" : "0";
  // Round to integer for all money values and when explicitly requested
  const shouldRound = isMoney || isInteger;
  if (shouldRound) {
    // Grouped here rather than via formatBalance: that helper switches to
    // scientific notation above 9 999 999 999, and total volume is approaching it.
    return (isMoney ? "$" : "") + groupIntegerDigits(Math.round(value).toString());
  }
  return formatBalance(value.toString(), { roundForFiat: true });
};
